export default __webpack_public_path__ + "static/media/android-studio-tool.8bca539c.jpg";